import { combineReducers } from 'redux';
import configuration from './configuration/reducer';


const root = combineReducers({
  configuration,
});

export default root;



// WEBPACK FOOTER //
// ../redux/store/services/api/reducer.js